var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 57,
    viewBox: "0 0 106 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0531837 47.7254C0.252215 45.5958 1.02843 42.1526 1.56582 39.9831C4.84983 26.8073 13.4082 15.3232 24.7529 8.05859L36.0778 26.7874C27.1811 32.2607 21.0708 42.4312 21.2301 53.0396H0.0531837C0.152699 51.308 -0.106041 49.457 0.0531837 47.7453V47.7254Z",
    fill: "#414042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.931 53.0204H84.754C84.8933 42.4121 78.8029 32.2615 69.9062 26.7682L80.833 8.01953C96.3575 17.175 106.17 34.9683 105.951 53.0403L105.931 53.0204Z",
    fill: "#414042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8714 5.88885L66.9844 24.956C57.8489 20.5972 47.8774 20.9157 38.6822 24.956L28.0938 5.88885C43.9366 -1.93307 62.0683 -1.99278 77.8714 5.88885Z",
    fill: "#414042"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6508 38.2129L55.121 55.9465C49.4287 57.897 45.3486 50.6523 50.7026 47.2887L73.6508 38.2129Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditScore);
export default __webpack_public_path__ + "static/media/CreditScore.b8e347600c69d57c6957d1f601a728b2.svg";
export { ForwardRef as ReactComponent };